import { useDeleteProductLogic } from './logic';
import { MimaButton, MimaText, Modal } from '../../../components';

const DeleteProduct = ({ closeModal, name, id }) => {
	const { onDelete, loading } = useDeleteProductLogic({ closeModal });

	return (
		<Modal closeModal={closeModal} goBack={closeModal}>
			<div style={{ width: '38rem' }}>
				<MimaText variant="subtitleBold" align="center" mb={3}>
					Delete Product
				</MimaText>

				<MimaText mb={2} align="center">
					Are you sure you want to delete Product{' '}
					<span
						style={{ fontWeight: '700', color: 'var(--color-fash-primary-3)' }}>
						{name}?
					</span>
				</MimaText>
			</div>

			<div className="modal__beside">
				<MimaButton
					title={'Yes'}
					width={18}
					onClick={() => onDelete(id)}
					loading={loading}
					variant="regular"
					buttonColor="var(--color-fash-primary)"
					titleColor="var(--color-dark)"
				/>

				<MimaButton
					title={'Cancel'}
					width={18}
					onClick={() => closeModal()}
					variant="regular"
				/>
			</div>
		</Modal>
	);
};

export default DeleteProduct;
